var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('p',[_vm._v("This chart shows last 60 days sensor activity")]),_c('apexchart',{ref:"chart",attrs:{"type":"area","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"text-main-gradient-secondary"},[_c('span',{staticClass:"material-icons"},[_vm._v("power_settings_new")]),_vm._v(" Active/Inactive jobs")])
}]

export { render, staticRenderFns }